import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    getRemoveRelationsProgress,
    removeAccountManagerBulk,
    stopBulkAction,
} from 'src/openapi/admin/apis/AccountManagerRemoveBulkApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {RemoveAccountTeamMemberModal} from './remove-account-team-member.modal';
import {
    selectRemoveAccountTeamMemberTask,
    selectRemoveAccountTeamMemberUuid,
    setBackgroundTask,
    setShown,
    setUuid,
} from './remove-account-team-member.slice';

import type {RemoveManagerRequest} from 'src/openapi/admin/models/RemoveManagerRequest';
import type {UserShortInfo} from 'src/openapi/admin/models/UserShortInfo';

type Props = {
    shown: boolean,
    accountTeamMember: UserShortInfo,
    accountIds: Array<number>,
    onDone: () => void,
    onClose: () => void,
};

export const RemoveAccountTeamMemberTool = ({shown, accountIds, onDone, accountTeamMember, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<RemoveManagerRequest>
            shown={shown}
            onClose={onClose}

            toolTask={TOOL_TASK}
            toolName={TOOL_TITLE}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectRemoveAccountTeamMemberTask}
            uuidSelector={selectRemoveAccountTeamMemberUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(removeManagerRequest, options) => (
                apiDispatch(removeAccountManagerBulk({...options, removeManagerRequest}))
            )}
            getProgress={id => apiDispatch(getRemoveRelationsProgress({id}))}
            stopAction={id => apiDispatch(stopBulkAction({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <RemoveAccountTeamMemberModal {...{accountIds, accountTeamMember, onCloseModal, processAction}}/>
            )}
        </BulkActionTool>
    );
};
